/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  CreateTotpRequest,
  CreateWebauthnRequest,
  FormResultForCompleteAuthWebauthnResponseAndCompleteAuthWebauthnErrors,
  FormResultForLoginPasswordResponseAndLoginPasswordErrors,
  FormResultForNullAndCreateTotpErrors,
  FormResultForNullAndDeletePasswordErrors,
  FormResultForNullAndDeleteWebauthnKeyErrors,
  FormResultForNullAndSetPasswordErrors,
  FormResultForNullAndSubmitCredentialsErrors,
  FormResultForStartLoginResponseAndStartLoginErrors,
  FormResultForVerifyTotpResponseAndVerifyTotpErrors,
  ListForGetAdminLoginsResponseItem,
  ListForGetVpnLoginsResponseItem,
  LoginPasswordRequest,
  SetPasswordRequest,
  StartInvitationResponse,
  StartLoginRequest,
  StartPostAuthResetResponse,
  VerifyTotpRequest,
} from '../models/index';

export interface BeginOidcAdminLoginRequest {
    provider_uuid: string;
    redirect_path?: string | null;
}

export interface BeginOidcTrufflepigLoginRequest {
    redirect_path?: string | null;
}

export interface BeginOidcVpnLoginRequest {
    tenant_uuid: string;
    token: string;
}

export interface CompleteAuthWebauthnRequest {
    body?: object;
}

export interface CompleteWebauthnRequest {
    body?: object;
}

export interface CreateTotpKeyRequest {
    CreateTotpRequest?: CreateTotpRequest;
}

export interface CreateWebauthnKeyRequest {
    CreateWebauthnRequest?: CreateWebauthnRequest;
}

export interface DeleteTotpKeyRequest {
    uuid: string;
}

export interface DeleteWebauthnKeyRequest {
    uuid: string;
}

export interface FinishOidcLoginRequest {
    code?: string;
    state?: string;
}

export interface LoginPasswordOperationRequest {
    LoginPasswordRequest?: LoginPasswordRequest;
}

export interface SetPasswordOperationRequest {
    SetPasswordRequest?: SetPasswordRequest;
}

export interface StartInvitationRequest {
    link_uuid: string;
}

export interface StartLoginOperationRequest {
    StartLoginRequest?: StartLoginRequest;
}

export interface VerifyTotpOperationRequest {
    VerifyTotpRequest?: VerifyTotpRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async beginOidcAdminLoginRaw(requestParameters: BeginOidcAdminLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['provider_uuid'] == null) {
            throw new runtime.RequiredError(
                'provider_uuid',
                'Required parameter "provider_uuid" was null or undefined when calling beginOidcAdminLogin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['redirect_path'] != null) {
            queryParameters['redirect_path'] = requestParameters['redirect_path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/begin-admin-login/{provider_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters['provider_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async beginOidcAdminLogin(requestParameters: BeginOidcAdminLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.beginOidcAdminLoginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async beginOidcTrufflepigLoginRaw(requestParameters: BeginOidcTrufflepigLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['redirect_path'] != null) {
            queryParameters['redirect_path'] = requestParameters['redirect_path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/begin-trufflepig-login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async beginOidcTrufflepigLogin(requestParameters: BeginOidcTrufflepigLoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.beginOidcTrufflepigLoginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async beginOidcVpnLoginRaw(requestParameters: BeginOidcVpnLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling beginOidcVpnLogin().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling beginOidcVpnLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/begin-vpn-login/{tenant_uuid}/{token}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))).replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async beginOidcVpnLogin(requestParameters: BeginOidcVpnLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.beginOidcVpnLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Complete the webauthn challenge for authentication
     * Complete the webauthn challenge for authentication
     */
    async completeAuthWebauthnRaw(requestParameters: CompleteAuthWebauthnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForCompleteAuthWebauthnResponseAndCompleteAuthWebauthnErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/auth/complete-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Complete the webauthn challenge for authentication
     * Complete the webauthn challenge for authentication
     */
    async completeAuthWebauthn(requestParameters: CompleteAuthWebauthnRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForCompleteAuthWebauthnResponseAndCompleteAuthWebauthnErrors> {
        const response = await this.completeAuthWebauthnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Complete the webauthn challenge for adding a new key  This may only be called between prepare and submit.
     * Complete the webauthn challenge for adding a new key
     */
    async completeWebauthnRaw(requestParameters: CompleteWebauthnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/credentials/complete-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Complete the webauthn challenge for adding a new key  This may only be called between prepare and submit.
     * Complete the webauthn challenge for adding a new key
     */
    async completeWebauthn(requestParameters: CompleteWebauthnRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.completeWebauthnRaw(requestParameters, initOverrides);
    }

    /**
     * Adds a TOTP key  This may only be called between prepare and submit.
     * Adds a TOTP key
     */
    async createTotpKeyRaw(requestParameters: CreateTotpKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateTotpErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/credentials/create-totp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTotpRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adds a TOTP key  This may only be called between prepare and submit.
     * Adds a TOTP key
     */
    async createTotpKey(requestParameters: CreateTotpKeyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateTotpErrors> {
        const response = await this.createTotpKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a webauthn key  This may only be called between prepare and submit.
     * Adds a webauthn key
     */
    async createWebauthnKeyRaw(requestParameters: CreateWebauthnKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/credentials/create-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateWebauthnRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Adds a webauthn key  This may only be called between prepare and submit.
     * Adds a webauthn key
     */
    async createWebauthnKey(requestParameters: CreateWebauthnKeyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.createWebauthnKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an already set password (and all MFA keys!)  This may only be called between prepare and submit.
     * Deletes an already set password (and all MFA keys!)
     */
    async deletePasswordRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeletePasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/delete-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Deletes an already set password (and all MFA keys!)  This may only be called between prepare and submit.
     * Deletes an already set password (and all MFA keys!)
     */
    async deletePassword(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeletePasswordErrors> {
        const response = await this.deletePasswordRaw(initOverrides);
        return await response.value();
    }

    /**
     * Removes a TOTP key  This may only be called between prepare and submit.
     * Removes a TOTP key
     */
    async deleteTotpKeyRaw(requestParameters: DeleteTotpKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteTotpKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/delete-totp/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a TOTP key  This may only be called between prepare and submit.
     * Removes a TOTP key
     */
    async deleteTotpKey(requestParameters: DeleteTotpKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTotpKeyRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a webauthn key  This may only be called between prepare and submit.
     * Removes a webauthn key
     */
    async deleteWebauthnKeyRaw(requestParameters: DeleteWebauthnKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteWebauthnKeyErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteWebauthnKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/delete-webauthn/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Removes a webauthn key  This may only be called between prepare and submit.
     * Removes a webauthn key
     */
    async deleteWebauthnKey(requestParameters: DeleteWebauthnKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteWebauthnKeyErrors> {
        const response = await this.deleteWebauthnKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async finishOidcLoginRaw(requestParameters: FinishOidcLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/finish-login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async finishOidcLogin(requestParameters: FinishOidcLoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finishOidcLoginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAdminLoginsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForGetAdminLoginsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/get-admin-logins`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAdminLogins(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForGetAdminLoginsResponseItem> {
        const response = await this.getAdminLoginsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getVpnLoginsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForGetVpnLoginsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/get-vpn-logins`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVpnLogins(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForGetVpnLoginsResponseItem> {
        const response = await this.getVpnLoginsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Local login using a password  Might require another factor
     * Local login using a password
     */
    async loginPasswordRaw(requestParameters: LoginPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForLoginPasswordResponseAndLoginPasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/auth/login-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['LoginPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Local login using a password  Might require another factor
     * Local login using a password
     */
    async loginPassword(requestParameters: LoginPasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForLoginPasswordResponseAndLoginPasswordErrors> {
        const response = await this.loginPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Local login using webauthn  Doesn\'t require another factor
     * Local login using webauthn
     */
    async loginWebauthnRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/auth/login-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Local login using webauthn  Doesn\'t require another factor
     * Local login using webauthn
     */
    async loginWebauthn(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.loginWebauthnRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async logoutAdminRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/oidc/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logoutAdmin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutAdminRaw(initOverrides);
    }

    /**
     */
    async logoutUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logoutUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutUserRaw(initOverrides);
    }

    /**
     * Sets a new password (overwriting an already set one)  This may only be called between prepare and submit.
     * Sets a new password (overwriting an already set one)
     */
    async setPasswordRaw(requestParameters: SetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetPasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/credentials/set-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sets a new password (overwriting an already set one)  This may only be called between prepare and submit.
     * Sets a new password (overwriting an already set one)
     */
    async setPassword(requestParameters: SetPasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetPasswordErrors> {
        const response = await this.setPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Starts the credential setup for an invitation to accept
     * Starts the credential setup for an invitation to accept
     */
    async startInvitationRaw(requestParameters: StartInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartInvitationResponse>> {
        if (requestParameters['link_uuid'] == null) {
            throw new runtime.RequiredError(
                'link_uuid',
                'Required parameter "link_uuid" was null or undefined when calling startInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/start-invitation/{link_uuid}`.replace(`{${"link_uuid"}}`, encodeURIComponent(String(requestParameters['link_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Starts the credential setup for an invitation to accept
     * Starts the credential setup for an invitation to accept
     */
    async startInvitation(requestParameters: StartInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartInvitationResponse> {
        const response = await this.startInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the login flows available to a user
     * Get the login flows available to a user
     */
    async startLoginRaw(requestParameters: StartLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForStartLoginResponseAndStartLoginErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/auth/start-login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartLoginRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the login flows available to a user
     * Get the login flows available to a user
     */
    async startLogin(requestParameters: StartLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForStartLoginResponseAndStartLoginErrors> {
        const response = await this.startLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the current state of a reset requested by an auth endpoint  This happens when the policy for local credentials is hardened and a local user with weaker credentials wants to log in.  It does not change any state.  It is named `start_` and uses `POST` to be consistent with the other endpoints which the frontend calls to start or resume a credentials reset.
     * Returns the current state of a reset requested by an auth endpoint
     */
    async startPostAuthResetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartPostAuthResetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/start-post-auth-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns the current state of a reset requested by an auth endpoint  This happens when the policy for local credentials is hardened and a local user with weaker credentials wants to log in.  It does not change any state.  It is named `start_` and uses `POST` to be consistent with the other endpoints which the frontend calls to start or resume a credentials reset.
     * Returns the current state of a reset requested by an auth endpoint
     */
    async startPostAuthReset(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartPostAuthResetResponse> {
        const response = await this.startPostAuthResetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Submits the credentials, accepting the invitation or completing the reset  This may only be called after prepare.
     * Submits the credentials, accepting the invitation or completing the reset
     */
    async submitCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSubmitCredentialsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/credentials/submit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Submits the credentials, accepting the invitation or completing the reset  This may only be called after prepare.
     * Submits the credentials, accepting the invitation or completing the reset
     */
    async submitCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSubmitCredentialsErrors> {
        const response = await this.submitCredentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Verify a password login using a TOTP key
     * Verify a password login using a TOTP key
     */
    async verifyTotpRaw(requestParameters: VerifyTotpOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForVerifyTotpResponseAndVerifyTotpErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/auth/verify-totp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['VerifyTotpRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Verify a password login using a TOTP key
     * Verify a password login using a TOTP key
     */
    async verifyTotp(requestParameters: VerifyTotpOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForVerifyTotpResponseAndVerifyTotpErrors> {
        const response = await this.verifyTotpRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
